import script from "./TimerView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimerView.vue?vue&type=script&setup=true&lang=ts"

import "./TimerView.vue?vue&type=style&index=0&id=03e89e3c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e89e3c"]])

export default __exports__